import MediaRecorder from 'audio-recorder-polyfill/index';

const recorderPolyfill = {
    analyser: undefined,
    mediaRecorder: undefined,
    endRecording: undefined,
    audioContext: undefined,

    init(audioContext, source, stream, analyser) {
        this.analyser = analyser;
        this.audioContext = audioContext;

        try {
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.addEventListener('dataavailable', this.handleDataAvailable.bind(this));
        } catch (e) {
            alert('Exception while creating MediaRecorder Polyfill!');
        }
    },
    record() {
        if (this.mediaRecorder)
            this.mediaRecorder.start();
    },
    stop(endRecording) {
        this.endRecording = endRecording;

        if (this.mediaRecorder)
            this.mediaRecorder.stop();
    },
    handleDataAvailable(event) {
        if (event.data && event.data.size > 0) {
            const blob = new Blob([event.data], {'type': event.data.type}); // audio/wav

            if (this.endRecording)
                this.endRecording(blob);
        }
    },
    microphoneLevel() {
        var array = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.getByteFrequencyData(array);

        return this.getAverageVolume(array);
    },
    getAverageVolume(array) {
        var values = 0;
        var average;
        var i;
        var length = array.length;

        // get all the frequency amplitudes
        for (i = 0; i < length; i++) {
            values += array[i];
        }

        average = values / length;

        return average;
    },
    cancelStream() {
    }
};

export default recorderPolyfill;



/** WEBPACK FOOTER **
 ** ./src/components/utils/RecorderPolyfill.js
 **/